import { render, staticRenderFns } from "./SdkPersonId.vue?vue&type=template&id=482d45c0"
import script from "./SdkPersonId.vue?vue&type=script&lang=js"
export * from "./SdkPersonId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports